import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPrivacy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m16 26 8-7.35V8.15L16 5 8 8.15v10.5z"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcPrivacy;
